import React, { Component } from 'react';

class Pagetop extends Component {
    constructor(props) {
        super();
        this.state = { pageTitle: props.title };
    }

    render() {
        return (
            <div style={{
                position: 'relative',
                overflow: 'hidden',
                width: '100%',
                minHeight: 'clamp(240px, 40vw, 420px)'
            }}>
                {/* Background Image with navy overlay */}
                <div style={{
                    position: 'absolute',
                    top: 0, left: 0, right: 0, bottom: 0,
                    backgroundImage: "url('/images/kampala-somali-awards.jpeg')",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center top',
                    backgroundRepeat: 'no-repeat',
                    backgroundColor: '#0D1630'
                }}>
                    <div style={{
                        position: 'absolute',
                        top: 0, left: 0, right: 0, bottom: 0,
                        background: 'linear-gradient(135deg, rgba(13,22,48,0.70) 0%, rgba(27,43,92,0.50) 50%, rgba(13,22,48,0.65) 100%)'
                    }} />
                </div>

                {/* Main Content */}
                <div style={{ position: 'relative', zIndex: 10, padding: 'clamp(2.5rem, 8vw, 5.5rem) 0 5rem 0' }}>
                    <div style={{ maxWidth: '72rem', margin: '0 auto', padding: '0 1rem' }}>
                        <div style={{ textAlign: 'center' }}>

                            {/* Badge — brand navy */}
                            <div style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                padding: '0.5rem 1.25rem',
                                background: 'rgba(27,43,92,0.75)',
                                backdropFilter: 'blur(8px)',
                                color: 'white',
                                fontSize: '0.8rem',
                                fontWeight: '600',
                                borderRadius: '9999px',
                                border: '1px solid rgba(46,139,84,0.5)',
                                marginBottom: '1.25rem',
                                letterSpacing: '0.08em',
                                textTransform: 'uppercase'
                            }}>
                                <span style={{
                                    width: '0.45rem',
                                    height: '0.45rem',
                                    backgroundColor: '#2E8B54',
                                    borderRadius: '50%',
                                    marginRight: '0.5rem',
                                    flexShrink: 0
                                }} />
                                SOYAN Initiative
                            </div>

                            {/* Main Title */}
                            <h1 style={{
                                fontSize: 'clamp(1.75rem, 5vw, 3.5rem)',
                                fontWeight: '800',
                                color: 'white',
                                marginBottom: '1.25rem',
                                lineHeight: '1.15',
                                textShadow: '0 4px 24px rgba(0,0,0,0.3)'
                            }}>
                                {this.props.title}
                            </h1>

                            {/* Brand orange underline */}
                            <div style={{
                                width: '5rem',
                                height: '0.25rem',
                                background: 'linear-gradient(to right, #2E8B54, #237A4B, #2E8B54)',
                                margin: '0 auto 1.75rem auto',
                                borderRadius: '9999px'
                            }} />

                            {/* Breadcrumb */}
                            <nav style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '0.6rem',
                                fontSize: '0.875rem'
                            }}>
                                <a
                                    href="/"
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        color: '#e5e7eb',
                                        textDecoration: 'none',
                                        transition: 'color 0.2s ease'
                                    }}
                                    onMouseEnter={e => e.currentTarget.style.color = '#2E8B54'}
                                    onMouseLeave={e => e.currentTarget.style.color = '#e5e7eb'}
                                >
                                    <svg style={{ width: '1rem', height: '1rem', marginRight: '0.4rem' }} fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
                                    </svg>
                                    Home
                                </a>

                                {/* Separator dots — brand orange */}
                                <div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
                                    {[0, 1, 2].map(i => (
                                        <div key={i} style={{
                                            width: '4px', height: '4px',
                                            backgroundColor: '#2E8B54',
                                            borderRadius: '50%',
                                            opacity: 0.7
                                        }} />
                                    ))}
                                </div>

                                <span style={{ color: '#2E8B54', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '0.35rem' }}>
                                    <svg style={{ width: '1rem', height: '1rem' }} fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                                    </svg>
                                    {this.props.title}
                                </span>
                            </nav>
                        </div>
                    </div>
                </div>

                {/* Bottom wave — white */}
                <div style={{ position: 'absolute', bottom: 0, left: 0, width: '100%', zIndex: 5 }}>
                    <svg style={{ width: '100%', height: '3rem', display: 'block' }} viewBox="0 0 1200 120" preserveAspectRatio="none">
                        <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" opacity="0.25" fill="white" />
                        <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.46,72.8,12.15,120.16,6.92,35.8-3.91,69.38-18.15,97.38-37.21,25.66-17.76,45.47-42.21,60.37-68.83,18.77-33.17,25.56-68.75,23.3-104.3-1.69-27.11-9.47-54.38-22.34-79.06C1059.49,25,1113-14.29,1200,52.47V0Z" opacity="0.5" fill="white" />
                        <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z" fill="white" />
                    </svg>
                </div>
            </div>
        );
    }
}

export default Pagetop;
